import React from 'react';
import { ArrowRight } from 'lucide-react';
const CHECKOUT_URL = 'https://coresolutionsg.com/cart/47471692546235:1';
interface SalesButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
  onClick?: () => void;
}
export function SalesButton({
  children,
  className = '',
  variant = 'primary',
  onClick
}: SalesButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 shadow-lg';
  const variants = {
    primary: 'bg-rose-600 hover:bg-rose-700 text-white focus:ring-rose-500 shadow-rose-200',
    secondary: 'bg-white hover:bg-gray-50 text-rose-600 border-2 border-rose-100 focus:ring-rose-500'
  };
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Fire AddToCart Meta Pixel event
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-143">
      {children}
      <ArrowRight className="ml-2 h-5 w-5" data-id="element-144" />
    </a>;
}